import { Navigate, useLocation } from 'react-router-dom';

interface StatePreservingNavigateProps {
  to: string;
  /** Forward the query string too: a moved page's filters live in it. */
  keepSearch?: boolean;
}

// A redirect that forwards the incoming location.state. Plain <Navigate> drops
// state, which broke the competition "Duplicate" flow: the card passes the
// source id via state to /admin/competition/create, which redirects here.
const StatePreservingNavigate = ({
  to,
  keepSearch = false,
}: StatePreservingNavigateProps) => {
  const location = useLocation();
  return (
    <Navigate
      to={keepSearch ? `${to}${location.search}` : to}
      state={location.state}
      replace
    />
  );
};

export default StatePreservingNavigate;
